import React from 'react';

class Notfound extends React.Component {
    render() {
        return (<div className="bg-gradient-primary">404 Not found.....</div>);
    }
}

export default Notfound;